// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_p3-8";
export var editMode = "_p3-3";
export var headerRow = "_p3-a";
export var headerTitle = "_p3-b";
export var product = "_p3-1";
export var productDetails = "_p3-5";
export var productDivider = "_p3-7";
export var productImage = "_p3-2";
export var productInfo = "_p3-4";
export var productTitle = "_p3-6";
export var strikethrough = "_p3-9";
export var upsellProductsCard = "_p3-0";